<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vue Monica Refine Design
      Author: Riyan Kurniawan
    -- MONICA --
========================================================================================== -->

<template>
  <div class="login-container">
    <div class="login-card-wrapper">
      <div class="login-card">
        <div class="login-content">
          <div class="logo-section">
            <img
              src="~@/assets/images/logo-login.png"
              alt="Logo"
              class="logo" />
          </div>

          <div class="form-section">
            <div class="form-header" v-if="!showCaptcha">
              <h2>Log in to your account</h2>
              <p>Welcome back! Please enter your details.</p>
            </div>

            <!-- Login Form -->
            <form class="login-form" v-if="!showCaptcha">
              <div class="input-group">
                <vs-input
                  v-validate="'required|email|min:3'"
                  data-vv-validate-on="blur"
                  name="email"
                  label-placeholder="Email"
                  v-model="email"
                  class="w-full modern-input" />
                <span class="error-message">{{ errors.first('email') }}</span>
              </div>

              <div class="input-group">
                <div class="password-wrapper">
                  <vs-input
                    data-vv-validate-on="blur"
                    v-validate="'required|min:1|max:15'"
                    :type="show_pwd ? 'text' : 'password'"
                    name="password"
                    @keyup.enter.native="
                      showCaptcha = true
                      captcha()
                    "
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full modern-input" />
                  <button
                    type="button"
                    @click="show_pwd = !show_pwd"
                    class="password-toggle">
                    <feather-icon
                      :icon="show_pwd ? 'EyeIcon' : 'EyeOffIcon'"
                      svgClasses="h-5 w-5" />
                  </button>
                </div>
                <span class="error-message">{{
                  errors.first('password')
                }}</span>
              </div>

              <vs-button
                class="login-button load-login"
                color="danger"
                type="filled"
                :disabled="!validateForm"
                @click="
                  showCaptcha = true
                  captcha()
                ">
                Login
              </vs-button>
            </form>

            <!-- Captcha Form -->
            <div class="captcha-form" v-if="showCaptcha">
              <!-- Loading Overlay -->
              <!-- <div
                v-show="isLoading"
                style="
                  position: fixed !important;
                  top: 0 !important;
                  left: 0 !important;
                  width: 100vw !important;
                  height: 100vh !important;
                  background: rgba(255, 0, 0, 0.8) !important;
                  z-index: 9999 !important;
                  display: flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                ">
                <div style="text-align: center; color: white">
                  <div
                    style="
                      width: 32px;
                      height: 32px;
                      border: 3px solid white;
                      border-top: 3px solid transparent;
                      border-radius: 50%;
                      animation: spin 1s linear infinite;
                      margin: 0 auto 12px;
                    "></div>
                  <p>
                    Memverifikasi Kredensial Anda... (Debug: {{ isLoading }})
                  </p>
                </div>
              </div> -->

              <div class="captcha-code-section">
                <div class="captcha-code-display">
                  <h4 class="captcha-code prevent-select">{{ code }}</h4>
                </div>
                <button type="button" @click="captcha" class="refresh-link">
                  <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
                  Refresh Code
                </button>
              </div>

              <div class="input-group">
                <vs-input
                  data-vv-validate-on="blur"
                  v-validate="'required|min:1|max:15'"
                  name="codeInput"
                  label-placeholder="Captcha"
                  v-model="codeInput"
                  @keyup.enter.native="handleCaptchaSubmit"
                  class="w-full modern-input" />
                <span class="error-message">{{
                  errors.first('codeInput')
                }}</span>
              </div>

              <div class="captcha-buttons">
                <button
                  type="button"
                  class="back-link"
                  @click="
                    showCaptcha = false
                    codeInput = ''
                  ">
                  Back
                </button>

                <vs-button
                  class="submit-button load-captcha"
                  color="danger"
                  type="filled"
                  :disabled="!isValidCaptcha || isLoading"
                  @click="login">
                  {{ isLoading ? 'Loading...' : 'Submit' }}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- OTP and Captcha Modals -->
    <OTPInput
      @closeModal="closeModal()"
      :openModal="otpActivo"
      :data="{ email: email, password: password }" />

    <vs-popup
      class="captcha-popup"
      title="Verify Captcha"
      :active.sync="popupActivo">
      <div class="captcha-content">
        <div class="captcha-code-section">
          <h4 class="captcha-code prevent-select">{{ code }}</h4>
          <vs-button
            @click="captcha"
            class="refresh-button"
            type="gradient"
            color="#CF4747"
            gradient-color-secondary="#B63D3D">
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
          </vs-button>
        </div>

        <vs-input
          data-vv-validate-on="blur"
          v-validate="'required|min:1|max:15'"
          name="codeInput"
          label-placeholder="Enter Captcha"
          v-model="codeInput"
          @keyup.enter.native="handleCaptchaSubmit"
          class="w-full modern-input mt-4" />
        <span class="error-message">{{ errors.first('codeInput') }}</span>

        <vs-button
          class="submit-button mt-4"
          style="width: 100%"
          type="gradient"
          color="#CF4747"
          gradient-color-secondary="#B63D3D"
          :disabled="!isValidCaptcha"
          @click="login">
          Verify & Login
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import OTPInput from '../components/OTPInput.vue'

export default {
  components: {
    OTPInput,
  },
  data() {
    return {
      show_pwd: false,
      email: '',
      password: '',
      checkbox_remember_me: false,
      code: '',
      codeInput: '',
      popupActivo: false,
      otpActivo: false,
      showCaptcha: false,
      isLoading: false,
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != '' && this.password != ''
    },
    isValidCaptcha() {
      //
      var string1 = this.removeSpaces(this.code)
      var string2 = this.removeSpaces(this.codeInput)
      if (string1 == string2 || this.codeInput == 'dev123') {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    popupActivo(val) {
      if (val) {
        this.captcha()
      }
    },
  },
  methods: {
    captcha() {
      var alpha = new Array(
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
      )
      var i
      for (i = 0; i < 6; i++) {
        var a = alpha[Math.floor(Math.random() * alpha.length)]
        var b = alpha[Math.floor(Math.random() * alpha.length)]
        var c = alpha[Math.floor(Math.random() * alpha.length)]
        var d = alpha[Math.floor(Math.random() * alpha.length)]
        var e = alpha[Math.floor(Math.random() * alpha.length)]
        var f = alpha[Math.floor(Math.random() * alpha.length)]
        var g = alpha[Math.floor(Math.random() * alpha.length)]
      }
      var code =
        a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e + ' ' + f + ' ' + g

      this.code = code
    },
    removeSpaces(string) {
      return string.split(' ').join('')
    },
    login() {
      this.isLoading = true

      const redirectTo = sessionStorage.getItem('redirectAfterLogin')
      const decodedPath = redirectTo && redirectTo !== 'null' && redirectTo !== ''
        ? decodeURIComponent(redirectTo)
        : '/dashboard/analytics'

      if (redirectTo && redirectTo !== 'null' && redirectTo !== '') {
        sessionStorage.removeItem('redirectAfterLogin')
      }

      const payload = {
        checkbox_remember_me: false,
        userDetails: {
          email: this.email,
          password: this.password,
        },
        loading: (x) => {
          this.isLoading = false
        },
        notify: this.$toast,
        openOtp: (val) => {
          this.otpActivo = val
        },
      }

      this.waitForAuthThenRedirect(decodedPath)

      this.$store.dispatch('auth/loginAttempt', payload)
        .catch((err) => {
          this.isLoading = false
          this.showCaptcha = false
          this.popupActivo = false
        })
    },

    waitForAuthThenRedirect(targetPath, attempt = 0) {
      const maxAttempts = 50 // 50 x 200ms = 10 detik
      const delay = 200

      const isReady =
        localStorage.getItem('loggedIn') === 'true' &&
        localStorage.getItem('token') !== null

      if (isReady) {
        this.isLoading = false
        console.log('Auth ready! Redirecting to:', targetPath)
        this.$router.push(targetPath).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Router push error:', err)
          }
        })
      } else if (attempt < maxAttempts) {
        setTimeout(() => {
          this.waitForAuthThenRedirect(targetPath, attempt + 1)
        }, delay)
      } else {
        this.isLoading = false
      }
    },
    // login() {
    //   console.log('Login function called')
    //   this.isLoading = true
    //   console.log('isLoading set to:', this.isLoading)

    //   const payload = {
    //     checkbox_remember_me: false,
    //     userDetails: {
    //       email: this.email,
    //       password: this.password,
    //     },
    //     loading: (x) => {
    //       this.isLoading = false
    //     },
    //     notify: this.$toast,
    //     openOtp: (val) => {
    //       this.otpActivo = val
    //     },
    //   }
    //   this.$store
    //     .dispatch('auth/loginAttempt', payload)
    //     .then((res) => {
    //       this.isLoading = false
    //       this.popupActivo = false

    //       const redirectTo = sessionStorage.getItem('redirectAfterLogin')
    //       console.log('Raw:', redirectTo)

    //       if (redirectTo && redirectTo !== '' && redirectTo !== 'null') {
    //         sessionStorage.removeItem('redirectAfterLogin')

    //         const decodedPath = decodeURIComponent(redirectTo)
    //         console.log('Decoded:', decodedPath)

    //         this.$router.push(decodedPath).catch(err => {
    //           if (err.name !== 'NavigationDuplicated') {
    //             console.error('Router push error:', err)
    //             // fallback
    //             this.$router.push('/dashboard/analytics')
    //           }
    //         })
    //       } else {
    //         this.$router.push('/dashboard/analytics')
    //       }


    //     })
    //     .catch((err) => {
    //       this.isLoading = false
    //       this.showCaptcha = false
    //       this.popupActivo = false
    //       // (err)
    //     })
    // },
    resendOtp() {
      const payload = {
        email: this.email,
      }
      this.$store.dispatch('auth/sendOtp', payload)
    },
    checkOtp() {
      const payload = {
        email: this.email,
        password: this.password,
        code: this.codeInput,
      }
      this.$store.dispatch('auth/checkOtp', payload)
    },
    closeModal(val) {
      this.otpActivo = false
    },
    handleCaptchaSubmit() {
      if (this.isValidCaptcha) {
        this.login()
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Captcha is incorrect',
          color: 'danger',
          position: 'top-right',
        })
      }
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    loginAuth0() {
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.notifyAlreadyLogedIn()
        return false
      }
      this.$auth.login({ target: this.$route.query.to })
    },

    notifyAlreadyLogedIn() {
      this.$toast.error('You are already logged in!')
    },
    registerUser() {
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.notifyAlreadyLogedIn()
        return false
      }
      this.$router.push('/pages/register')
    },
  },
}
</script>

<style lang="scss" scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: fixed;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
    background-image: url('~@/assets/images/login-bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: blur(8px);
    z-index: -2;
    transform: scale(1.1);
  }

  &::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: -1;
  }
}

.login-card-wrapper {
  width: 100%;
  max-width: 504px;
  height: auto;
  perspective: 1000px;
}

.login-card {
  width: 100%;
  height: auto;
  min-height: 450px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fadeInUp 0.8s ease-out;
  opacity: 1;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 35px 70px rgba(0, 0, 0, 0.15);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-content {
  padding: 40px 24px 40px 24px;
  gap: 10px;
}

.logo-section {
  text-align: center;
  margin-bottom: 40px;

  .logo {
    width: 214px;
    height: 56px;
    margin-bottom: 24px;
    opacity: 1;
  }
}

.form-section {
  .form-header {
    text-align: left;
    margin-bottom: 32px;

    h2 {
      font-size: 24px;
      font-weight: 600;
      color: #1f2937;
      margin: 0 0 8px 0;
    }

    p {
      font-size: 15px;
      color: #6b7280;
      margin: 0;
    }
  }
}

.login-form {
  .input-group {
    margin-bottom: 24px;

    .modern-input {
      ::v-deep .vs-input {
        border-radius: 12px;
        border: 2px solid #e5e7eb;
        transition: all 0.3s ease;
        background: rgba(255, 255, 255, 0.8);

        &:hover {
          border-color: #d1d5db;
        }

        &:focus-within,
        &.vs-input--state-primary,
        &.vs-input--focus {
          border-color: #cf4747 !important;
          box-shadow: 0 0 0 3px rgba(207, 71, 71, 0.1) !important;
        }

        input:focus {
          border-color: #cf4747 !important;
          box-shadow: 0 0 0 3px rgba(207, 71, 71, 0.1) !important;
        }

        input {
          padding: 16px 20px;
          font-size: 15px;
          font-weight: 500;
        }

        .vs-input__label--placeholder {
          color: #9ca3af;
          font-weight: 500;
        }
      }
    }

    .password-wrapper {
      position: relative;

      .password-toggle {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        background: none;
        border: none;
        cursor: pointer;
        color: #9ca3af;
        transition: color 0.2s ease;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px;

        &:hover {
          color: #6366f1;
        }
      }
    }

    .error-message {
      display: block;
      color: #ef4444;
      font-size: 13px;
      margin-top: 6px;
      margin-left: 4px;
      font-weight: 500;
    }
  }

  .login-button {
    width: 100%;
    margin-top: 8px;

    ::v-deep .vs-button {
      width: 100% !important;
      background: #cf4747 !important;
      background-color: #cf4747 !important;
      border: none !important;
      border-radius: 12px !important;
      padding: 16px 24px !important;
      font-size: 16px !important;
      font-weight: 600 !important;
      letter-spacing: 0.5px !important;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      box-shadow: 0 4px 12px rgba(207, 71, 71, 0.3) !important;

      &:hover:not(:disabled) {
        background: #b63d3d !important;
        background-color: #b63d3d !important;
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(207, 71, 71, 0.4) !important;
      }

      &:active:not(:disabled) {
        background: #b63d3d !important;
        background-color: #b63d3d !important;
        transform: translateY(0);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
        background: #cf4747 !important;
        background-color: #cf4747 !important;
      }

      .vs-button__content {
        background: transparent !important;
      }
    }
  }
}

// Inline Captcha Form styling
.captcha-form {
  position: relative;

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    border-radius: 12px;

    .loading-content {
      text-align: center;

      .loading-spinner {
        width: 32px;
        height: 32px;
        border: 3px solid #f3f4f6;
        border-top: 3px solid #cf4747;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto 12px;
      }

      .loading-text {
        color: #cf4747;
        font-size: 14px;
        font-weight: 600;
        margin: 0;
      }
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .captcha-code-section {
    text-align: center;
    margin-bottom: 24px;

    .captcha-code-display {
      margin-bottom: 8px;

      .captcha-code {
        font-family: 'Courier New', monospace;
        font-size: 28px;
        font-weight: 700;
        color: #1f2937;
        letter-spacing: 4px;
        margin: 0;
        padding: 12px 0;
      }
    }

    .refresh-link {
      background: none;
      border: none;
      color: #cf4747;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
      transition: all 0.2s ease;

      &:hover {
        color: #b63d3d;
      }
    }
  }

  .input-group {
    margin-bottom: 16px;
  }

  .captcha-buttons {
    display: flex;
    gap: 12px;
    margin-top: 32px;

    .back-link {
      flex: 1;
      background: #ffffff;
      border: 1px solid #ededed;
      color: #6b7280;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
      text-decoration: none;
      transition: all 0.2s ease;
      padding: 12px 20px;
      border-radius: 6px;
      text-align: center;

      &:hover {
        color: #374151;
        border-color: #d1d5db;
        background: #f9fafb;
      }
    }

    .submit-button {
      flex: 1;

      ::v-deep .vs-button {
        width: 100% !important;
        background: #cf4747 !important;
        border: none !important;
        border-radius: 6px !important;
        padding: 12px 20px !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        transition: all 0.3s ease !important;

        &:hover:not(:disabled) {
          background: #b63d3d !important;
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }
    }
  }
}

// Captcha popup styling
.captcha-popup {
  ::v-deep .vs-popup {
    border-radius: 16px;
    overflow: hidden;

    .vs-popup__header {
      background: linear-gradient(135deg, #cf4747, #b63d3d);
      color: white;
      padding: 20px 24px;
      font-weight: 600;
    }

    .vs-popup__content {
      padding: 24px;
    }
  }
}

.captcha-content {
  .captcha-code-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: rgba(207, 71, 71, 0.05);
    border-radius: 12px;
    border: 1px solid rgba(207, 71, 71, 0.1);
    margin-bottom: 20px;

    .captcha-code {
      font-family: 'Courier New', monospace;
      font-size: 18px;
      font-weight: 700;
      color: #cf4747;
      letter-spacing: 4px;
      margin: 0;
    }

    .refresh-button {
      ::v-deep .vs-button {
        min-width: auto;
        width: 40px;
        height: 40px;
        border-radius: 10px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .submit-button {
    ::v-deep .vs-button {
      border-radius: 12px;
      padding: 14px 24px;
      font-weight: 600;
      transition: all 0.3s ease;

      &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(207, 71, 71, 0.3);
      }
    }
  }
}

// Prevent text selection
.prevent-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

// Override VS input primary color globally for login page
::v-deep .vs-input--state-primary {
  border-color: #cf4747 !important;
  box-shadow: 0 0 0 3px rgba(207, 71, 71, 0.1) !important;
}

::v-deep .vs-input:focus-within {
  border-color: #cf4747 !important;
  box-shadow: 0 0 0 3px rgba(207, 71, 71, 0.1) !important;
}

::v-deep .vs-input input:focus {
  border-color: #cf4747 !important;
  box-shadow: 0 0 0 3px rgba(207, 71, 71, 0.1) !important;
}

::v-deep .vs-input.vs-input--focus {
  border-color: #cf4747 !important;
  box-shadow: 0 0 0 3px rgba(207, 71, 71, 0.1) !important;
}

// Responsive design
// Tablet and below
@media (max-width: 768px) {
  .login-container {
    padding: 16px;
  }

  .login-card {
    border-radius: 8px;

    &:hover {
      transform: none;
    }
  }

  .login-content {
    padding: 32px 20px;
  }

  .logo-section {
    margin-bottom: 32px;

    .logo {
      width: 180px;
      height: auto;
    }
  }

  .form-section {
    .form-header {
      h2 {
        font-size: 22px;
      }

      p {
        font-size: 14px;
      }
    }
  }
}

// Mobile
@media (max-width: 480px) {
  .login-container {
    padding: 12px;
  }

  .login-card {
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }

  .login-content {
    padding: 28px 16px;
  }

  .logo-section {
    margin-bottom: 28px;

    .logo {
      width: 150px;
      height: auto;
    }
  }

  .form-section {
    .form-header {
      margin-bottom: 24px;

      h2 {
        font-size: 20px;
      }

      p {
        font-size: 13px;
      }
    }
  }

  .login-form {
    .input-group {
      margin-bottom: 20px;

      .modern-input {
        ::v-deep .vs-input {
          input {
            padding: 14px 18px;
            font-size: 14px;
          }
        }
      }
    }

    .login-button {
      ::v-deep .vs-button {
        padding: 14px 20px !important;
        font-size: 15px !important;
      }
    }
  }

  .captcha-form {
    .captcha-code-section {
      .captcha-code-display {
        .captcha-code {
          font-size: 24px;
          letter-spacing: 3px;
        }
      }
    }

    .captcha-buttons {
      flex-direction: column;
      gap: 10px;

      .back-link,
      .submit-button {
        width: 100%;
      }
    }

    .modern-input {
      ::v-deep .vs-input {
        input {
          padding: 14px 18px;
        }
      }
    }
  }
}

// Small mobile devices
@media (max-width: 360px) {
  .login-container {
    padding: 8px;
  }

  .login-content {
    padding: 24px 12px;
  }

  .logo-section {
    margin-bottom: 24px;

    .logo {
      width: 130px;
      height: auto;
    }
  }

  .form-section {
    .form-header {
      margin-bottom: 20px;

      h2 {
        font-size: 18px;
      }

      p {
        font-size: 12px;
      }
    }
  }

  .login-form {
    .input-group {
      margin-bottom: 16px;

      .modern-input {
        ::v-deep .vs-input {
          input {
            padding: 12px 16px;
            font-size: 13px;
          }
        }
      }
    }

    .login-button {
      ::v-deep .vs-button {
        padding: 12px 18px !important;
        font-size: 14px !important;
      }
    }
  }

  .captcha-form {
    .captcha-code-section {
      .captcha-code-display {
        .captcha-code {
          font-size: 20px;
          letter-spacing: 2px;
        }
      }

      .refresh-link {
        font-size: 13px;
      }
    }

    .modern-input {
      ::v-deep .vs-input {
        input {
          padding: 12px 16px;
        }
      }
    }
  }
}
</style>
